function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Head from "next/head";
import { PureComponent } from "react";
import Topbar from "/components/core/top-bar-new/top-bar-component";
import Footer from "segments/desktop/footer/layouts/base-footer/base-footer-component";
import { MAIN_ID } from "constants/element-ids";
import CoreAddonsComponent from "/components/addons/core-addons/core-addons-component";
import BaseTemplate from "../base-template";
import SegmentsListComponent from "/components/segments/segments-list/segments-list-component";
import { LOGO_THEME_LIGHT_COLOR, LOGO_THEME_BLACK_COLOR, LOGO_THEME_BLACK, LOGO_THEME_LIGHT } from "/constants/logo-themes";
class LongTemplate extends PureComponent {
    render() {
        let { headerUrl, exitPopup, stickyMode, pageConfig, isPreview } = this.props;
        const { segments, topbar, footer, socialButtons, topBanner, exitPopupConfig } = pageConfig;
        const preventMenu = topbar && topbar.preventMenu;
        const preventFooter = footer && footer.preventFooter;
        return /*#__PURE__*/ _jsxs(BaseTemplate, _object_spread_props(_object_spread({}, this.props, pageConfig), {
            children: [
                /*#__PURE__*/ _jsx(Topbar, {
                    url: headerUrl,
                    loginTheme: pageConfig.loginTheme,
                    menuTheme: pageConfig.menuTheme,
                    logoTheme: LOGO_THEME_LIGHT_COLOR,
                    showMenu: !preventMenu,
                    stickyMode: stickyMode,
                    allowSocialButtons: socialButtons && socialButtons.show,
                    socialButtonsColor: socialButtons && socialButtons.color,
                    socialButtonBlogStyle: socialButtons && socialButtons.blogStyle,
                    topBanner: topBanner,
                    maxWidth: "100%",
                    headerBackgroundColor: "white"
                }),
                /*#__PURE__*/ _jsx("main", {
                    id: MAIN_ID,
                    children: /*#__PURE__*/ _jsx(SegmentsListComponent, {
                        segments: segments,
                        isPreview: isPreview
                    })
                }),
                !preventFooter && /*#__PURE__*/ _jsx(Footer, {}),
                /*#__PURE__*/ _jsx(CoreAddonsComponent, {
                    exitPopup: exitPopup,
                    exitPopupConfig: exitPopupConfig
                })
            ]
        }));
    }
}
export { LongTemplate as default };
LongTemplate.defaultProps = {
    headerUrl: "https://monday.com/",
    title: "monday.com",
    description: "",
    exitPopup: true,
    menuTheme: "",
    loginTheme: ""
};
